import styled, { css } from 'styled-components';
const CommonCodeStyles = css `
    background-color: ${(props) => props.theme.colors.codeBackground};
    font-family: ${(props) => props.theme.fonts.codeFontFamily};
    font-size: ${(props) => props.theme.fonts.textSizeStandard};
`;
export const CodeLine = styled.span `
    ${CommonCodeStyles}
    padding: 0.2rem;
`;
export const CodeBlock = styled.pre `
    ${CommonCodeStyles}
    padding: 2rem;
    overflow-x: 'auto';
`;
//# sourceMappingURL=Code.styles.js.map